import React from 'react';
import { Typography, Box, Alert, Stack } from '@mui/material';
import TaskCard from './TaskCard';

const TaskList = ({ tasks, loading, error }) => {
  // 如果有错误则显示错误信息
  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
        {error}
      </Alert>
    );
  }

  // 如果没有任务则返回null（会由父组件显示空状态）
  if (!tasks || tasks.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      
      <Stack spacing={1.5} sx={{ width: '100%' }}>
        {tasks.map((task) => (
          <TaskCard key={task.task_id} task={task} />
        ))}
      </Stack>
    </Box>
  );
};

export default TaskList; 